import { SMALL_SCREEN_SIZE_BREAKPOINT } from 'Constants/responsiveness';

/** Whether the viewport is below the small-screen breakpoint. */
export const getIsSmallScreen = (): boolean => {
  return window.innerWidth < SMALL_SCREEN_SIZE_BREAKPOINT;
};
